// A signed-in user with no home on this platform (data-model §2; FR-026, FR-028; R-4, R-5): a
// school-admin-only account on Android is told the console is on the web; an account with no role
// this app serves gets the FR-026 message. Log out ends the session (USER). No parent screen mounts
// and no request is made.
import { View } from "react-native";

import { AUTH_COPY } from "@/auth/copy";
import { useSessionController } from "@/session/hooks";
import type { Landing } from "@/session/types";
import { Button } from "@/ui/Button";
import { Text } from "@/ui/Text";

import { ProductHeader } from "./header/ProductHeader";
import { useScreenStyles } from "./screenStyles";

type Reason = Extract<Landing, { kind: "unsupported" }>["reason"];

const messages: Record<Reason, string> = {
  SCHOOL_ADMIN_ONLY_ON_ANDROID: AUTH_COPY.roles.schoolAdminOnWeb,
  NO_SERVED_ROLE: AUTH_COPY.refusals.noAccess,
};

export function UnsupportedRoleScreen({ reason }: { reason: Reason }) {
  const styles = useScreenStyles();
  const { signOut } = useSessionController();
  return (
    <View style={styles.screen} testID="unsupported-role-screen">
      <ProductHeader />
      <View style={styles.body} role="main">
        <Text variant="heading" accessibilityRole="header" aria-level={1}>
          {AUTH_COPY.product}
        </Text>
        <Text tone="muted" style={styles.message}>
          {messages[reason]}
        </Text>
        <Button
          variant="outline"
          onPress={() => void signOut("USER")}
          testID="unsupported-role-logout"
        >
          {AUTH_COPY.actions.logOut}
        </Button>
      </View>
    </View>
  );
}
